import i18n from '../../i18n.js'

export default function BusinessListBanner(){
    return(
        <div className="banner">
            <div className="section-title container">
                <h6>{i18n.t('business.banner.header-text')}</h6>
                <h1>
                    <span>{i18n.t('business.banner.title1')}</span> <span className="d-none d-sm-inline">{i18n.t('business.banner.title2')}</span>
                    <span className="d-inline d-sm-none"> <br />{i18n.t('business.banner.title3')}</span>
                </h1>
            </div>
        </div>
    )
}